import { Box, Grid2, LinearProgress, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { FormFieldKeyActionEnum } from "../../../_common/enum/forms/formFieldKeyAction.enum";
import { FormFieldValueTypeEnum } from "../../../_common/enum/forms/formFieldValueType.enum";
import { FormStatusEnum } from "../../../_common/enum/forms/formStatus.enum";
import { IFormFieldKeyManage } from "../../../_common/models/formFieldKey";
import { IFormTemplateSectionFormManage } from "../../../_common/models/formTemplateSection/formTemplateSectionFormManage.model";
import { StandardButton } from "../../../_components/button/primary.button";
import {
    checkIfDependancyMet,
    checkIfLookupDependancyMet,
    getDependencyConditionText,
    getField as getFormField,
    getSectionKeys,
    getSections,
    isFormValid,
    renderTable
} from "../../../_helpers/formField.helper";
import { handleErrorResponse, handleErrorResponseAxios } from "../../../_helpers/handleResponse.helper";
import { accountService } from "../../../_services/accounts.service";
import { formService } from "../../../_services/form.service";
import { formSectionService } from "../../../_services/formSection.service";
import { formTemplateSectionService } from "../../../_services/formTemplateSection.service";


export function FormSectionView(params: {
    formTemplateSectionId: number,
    formSectionId?: number,
    isSectionSaving?: boolean,
    isForReview?: boolean,
    actionId?: FormFieldKeyActionEnum,
    onSave: () => void,
    editable?: boolean,
    onEditFieldClick?: (field: IFormFieldKeyManage) => void,
    onEmptyCellClick?: (tableField: IFormFieldKeyManage, row: number, col: number) => void,
    count?: number
}) {
    const [data, setData] = useState<IFormTemplateSectionFormManage>();

    const [isLoading, setLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isContinue, setContinue] = useState(false);

    const { formId } = useParams<{ formId: string }>();
    const _formId = Number(formId ?? 0);

    const navigate = useNavigate();

    useEffect(() => {
        fetchTemplateSectionData();
    }, [params.formTemplateSectionId, params.count]);

    function fetchTemplateSectionData() {
        if (params.formTemplateSectionId == 0) return;
        setLoading(true);

        return formTemplateSectionService
            .getForm(params.formTemplateSectionId, _formId, params.isForReview, params.actionId)
            .then(
                (json) => {
                    setData(json);
                }
            )
            .finally(() => {
                setLoading(false);
            });
    }

    function handleChange(event: any, ffkId: number) {
        setData((_data: any) => {
            var __data = { ..._data };

            if (__data.formFieldKeys && __data.formFieldKeys.length) {
                var _formFieldKey = __data.formFieldKeys.find((ffk: IFormFieldKeyManage) => ffk.id === ffkId);
                var isCheckbox = _formFieldKey.formFieldValueTypeId === FormFieldValueTypeEnum.Checkbox;
                console.log(isCheckbox, event.target.checked, event.target.value);
                if (_formFieldKey.formField) {
                    _formFieldKey.formField.fieldValue = isCheckbox ? event.target.checked ? event.target.value : null : event.target.value;
                }
                else {
                    _formFieldKey.formField = {
                        id: 0,
                        fieldValue: isCheckbox ? event.target.checked ? event.target.value : null : event.target.value,
                        formFieldKeyId: _formFieldKey.id,
                        formTemplateSectionId: _formFieldKey.formTemplateSectionId,
                        formSectionId: params.formSectionId ?? 0
                    };
                }
            }
            return { ..._data } as IFormTemplateSectionFormManage;
        });
    };

    function submit(event: any) {
        setContinue(false)
        event.preventDefault();
        var _formFields: Array<any> = [];
        if (data && data.formFieldKeys && data.formFieldKeys.length) {
            _formFields = data.formFieldKeys.map(ffk => {
                var _formField = ffk.formField || {
                    id: 0,
                    fieldValue: "",
                    fieldValueTest: "",
                    formFieldKeyId: ffk.id,
                    formTemplateSectionId: ffk.formTemplateSectionId,
                    formSectionId: params.formSectionId ?? 0
                }

                return _formField;
            });
        }

        var form = {
            id: params.formSectionId ?? 0,
            formId: _formId ?? 0,
            formTemplateSectionId: params.formTemplateSectionId ?? 0,
            formSectionId: params.formSectionId ?? 0,
            formFields: _formFields
        };

        var formData = new FormData();
        formData.append(`id`, form.id.toString());
        formData.append(`formId`, form.formId.toString());
        formData.append(`formTemplateSectionId`, form.formTemplateSectionId.toString());
        formData.append(`formSectionId`, form.formSectionId.toString());

        form.formFields.forEach((formField, index) => {
            for (var formFieldName in formField) {
                var val = (formField as any)[formFieldName];
                formData.append(`formFields[${index}].${formFieldName}`, val || (val === null || val === "" || val === " " ? "" : 0));
            }
        });

        var documentUploadParentFields = document.getElementsByClassName("documentUpload");
        var documentsToClear: Array<string> = []

        if (documentUploadParentFields && documentUploadParentFields.length > 0) {
            var currentIndex = 0;

            Array.from(documentUploadParentFields).forEach((documentUploadParentField: any, index: number) => {

                var fileField = documentUploadParentField.getElementsByClassName("MuiInputBase-input")[0];
                documentsToClear.push(fileField.id);

                var id = fileField.id.split("_")[1];

                if (data && data.formFieldKeys && data.formFieldKeys.length && (fileField as any)?.files[0]) {
                    formData.append("file[" + currentIndex + "].file", (fileField as any)?.files[0]);
                    formData.append("file[" + currentIndex + "].formFieldKeyId", id);
                    currentIndex++
                }
            })
        }

        setIsSaving(true);
        formSectionService[params.actionId ? "updateOnFormActionSave" : "postFromData"](formData).then(
            (data) => {

                documentsToClear.forEach(d => {
                    var doc = document.getElementById(d);
                    (doc as any).value = null;
                });

                params.onSave();
            }, handleErrorResponseAxios)
            .finally(() => {
                setIsSaving(false)
            });
    }

    function getField(field: IFormFieldKeyManage, index: number) {
        const fieldElement = getFormField({
            field,
            fieldId: index,
            isForReview: params.isForReview || false,
            isLoading,
            isContinue,
            handleChange,
            globalFormFields: data?.globalFormFields,
            checkIfLookupDependancyMet: (ffkfl) => checkIfLookupDependancyMet(ffkfl, data?.globalFormFields)
        });

        if (!params.editable) {
            return fieldElement;
        }
        return (
            <Box
                data-field-wrapper="true"
                onClick={(e) => {
                    e.stopPropagation();
                    params.onEditFieldClick?.(field);
                }}
                sx={{
                    cursor: 'pointer',
                    p: 0.5,
                    borderRadius: 1,
                    transition: 'background-color 0.2s',
                    '&:hover': {
                        backgroundColor: 'action.hover'
                    }
                }}
            >
                {getDependencyConditionText(field).map(r => <Typography style={{ "fontSize": "12px", "color": "red" }}>{r}<br /></Typography>)}
                {fieldElement}
            </Box>
        );
    }

    function renderFieldsForSection(sectionId: any, editable?: boolean) {
        const sectionKeys = getSectionKeys(data, sectionId).filter(s => editable == true || checkIfDependancyMet(s, data));

        const tableFields = sectionKeys.filter(ffk => ffk.formFieldValueTypeId === FormFieldValueTypeEnum.Table);
        const regularFields = sectionKeys.filter(ffk =>
            ffk.formFieldValueTypeId !== FormFieldValueTypeEnum.Table &&
            ffk.formFieldValueTypeId !== FormFieldValueTypeEnum.SubSection &&
            !tableFields.some(tf => tf.id === ffk.subSectionId)
        );

        return (
            <>
                {regularFields.map((ffk, index) => (
                    <Grid2 key={"regular_field_" + sectionId + "_" + index + "_" + ffk.id} size={{ xs: ffk.xsWidth || 12, md: ffk.mdWidth || 12 }}>
                        {getField(ffk, ffk.id)}
                    </Grid2>
                ))}

                {tableFields.map((tableField, tableIndex) => (
                    <Grid2 key={"table_" + sectionId + "_" + tableIndex + "_" + tableField.id} size={{ xs: 12 }}>
                        {renderTable({
                            tableField,
                            allAvailableFields: data?.formFieldKeys || [],
                            data,
                            editable: params.editable,
                            onEditFieldClick: params.onEditFieldClick,
                            onEmptyCellClick: params.onEmptyCellClick,
                            getField
                        })}
                    </Grid2>
                ))}
            </>
        );
    }


    function withdraw() {
        if (window.confirm("Are you sure you want to withdraw this form?") == true) {
            setIsSaving(true);
            formService.disable(_formId, accountService.isAdmin ? FormStatusEnum.Cancelled : FormStatusEnum.Withdrawn).then(
                () => { navigate("../") },
                handleErrorResponse
            ).finally(() => {
                setIsSaving(false)
            });

        }
    }

    return (
        <Grid2 container spacing={1} style={{ padding: "0px" }} id="form-manage" key={"form_template_section_" + params.formTemplateSectionId + "_"}>
            <Grid2 size={{ xs: 12 }} sx={{ marginTop: "32px !important" }}>

                {(isLoading || saving || params.isSectionSaving) &&
                    <Paper>
                        <Typography variant="body1" className="paper-theme-body" gutterBottom>
                            <LinearProgress color="secondary" />
                        </Typography>
                    </Paper>
                }

                <ValidatorForm onSubmit={submit} noValidate>

                    {getSections(data).filter(s => params.editable == true || checkIfDependancyMet(s, data)).map((s, index) =>
                        <>
                            <Paper key={"section_" + s.id + "_" + index + "_"} sx={{ marginBottom: "8px", marginTop: "16px !important", paddingTop: "11px" }}>

                                <Grid2 container spacing={2} style={{ "padding": "8px" }}>
                                    {renderFieldsForSection(s.id, params.editable)}
                                </Grid2>

                            </Paper>
                        </>
                    )}

                    {!params.isForReview &&
                        <Grid2 container spacing={1} style={{ padding: "0px" }}>

                            <Grid2 size={{ xs: 4 }} >
                                <StandardButton onClick={withdraw} saving={isLoading || saving || params.isSectionSaving} icon="clear" variant="error" type="button">{accountService.isAdmin ? "Cancel" : "Withdraw"}</StandardButton>
                            </Grid2>

                            <Grid2 size={{ xs: 8 }} >
                                <StandardButton onClick={() => { setContinue(true) }} disabled={!isFormValid(data) && !accountService.isAdmin} icon={"check"} saving={isLoading || saving || params.isSectionSaving} variant="success" type="submit">Continue</StandardButton>
                            </Grid2>
                        </Grid2>
                    }

                </ValidatorForm >

            </Grid2 >

        </Grid2 >
    );
}